
import contentTypeBuilder from '@strapi/plugin-content-type-builder/strapi-admin';
import email from '@strapi/plugin-email/strapi-admin';
import upload from '@strapi/plugin-upload/strapi-admin';
import i18N from '@strapi/plugin-i18n/strapi-admin';
import comments from 'strapi-plugin-comments/strapi-admin';
import seo from '@strapi/plugin-seo/strapi-admin';
import ckeditor5 from '@_sh/strapi-plugin-ckeditor/strapi-admin';
import graphql from '@strapi/plugin-graphql/strapi-admin';
import usersPermissions from '@strapi/plugin-users-permissions/strapi-admin';
import excelExport from 'strapi-plugin-excel-export-2024/strapi-admin';
import translate from 'strapi-plugin-translate/strapi-admin';


const plugins = {
  'content-type-builder': contentTypeBuilder,
  'email': email,
  'upload': upload,
  'i18n': i18N,
  'comments': comments,
  'seo': seo,
  'ckeditor5': ckeditor5,
  'graphql': graphql,
  'users-permissions': usersPermissions,
  'excel-export': excelExport,
  'translate': translate,
};

export default plugins;
